<template>
    <section class="ds-settings-card">
        <header v-if="title || $slots.actions" class="ds-settings-card-header">
            <h2 v-if="title" class="ds-settings-card-title">{{ title }}</h2>
            <div v-if="$slots.actions" class="ds-settings-card-actions"><slot name="actions" /></div>
        </header>
        <slot />
    </section>
</template>

<script setup lang="ts">
defineProps<{
    title?: string
}>()
</script>
